import React from "react";
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Typography,
} from "@mui/material";

import { profileThemeColors } from "../../config/profileThemeColors";

import { styles, ColorRadio } from "./styles";

const ProfileThemePicker = ({ label = "", name, values, setFieldValue }) => {
  return (
    <FormControl component="fieldset" sx={styles.formControl}>
      <Typography
        variant="p"
        component="label"
        marginBottom="12px"
        sx={styles.title}
      >
        {label}
      </Typography>

      <RadioGroup
        row
        name={name}
        value={values[name]}
        onChange={(e) => setFieldValue(name, e.target.value)}
        sx={styles.radioGroup}
      >
        {Object.keys(profileThemeColors).map((colorId) => (
          <FormControlLabel
            key={colorId}
            value={colorId}
            control={
              <ColorRadio paint={colorId} selected={values[name] === colorId} />
            }
            sx={styles.formControlLabel}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default ProfileThemePicker;
